module.exports = __webpack_public_path__ + "static/media/etherscan.53972531.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/etherscan.png
// module id = 589
// module chunks = 0